import axios from "axios";
import Config from "src/config";

const v2_actionDadosUsuario = (usuarioId) => {
    return axios({
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/usuarios/${usuarioId}`
    });
};

export default v2_actionDadosUsuario;
